(function () {
  'use strict';
  angular.module('com.module.users', ['com.module.authproviders']);

})();
